import ApiMsProjectsService from '@/services/ms_projects_service'
export const state = {
  loading: false
}

export const getters = {
  loading: (state) => state.loading
}

export const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload
  }
}

export const actions = {
  async uploadDocumentFromPlace({ commit }, payload) {
    commit('SET_LOADING', true)
    try {
      const resp = await ApiMsProjectsService.post(`/upload_document`, payload)
      return resp
    } catch (error) {
      return error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}
